import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { ICreateProductRequest, IProduct, IUpdateProductRequest } from '../models/product';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(private http: HttpClient) { }

  getProduct(id :string){
    return this.http.get<IProduct>(
      `${environment.baseUrl}/v1/products/getproduct/${id}`
    )
  }

  getProductByInternalNumber(internalNumber :string){
    return this.http.get<IProduct>(
      `${environment.baseUrl}/v1/products/getProductByNumber/${internalNumber}`
    )
  }

  listProducts(request: IBaseSearchRequest){
    return this.http.post<IPagedResults<IProduct[]>>(
      `${environment.baseUrl}/v1/products/searchproducts`,
      request
    )
  }

  addProduct(request : ICreateProductRequest){
    return this.http.post<IProduct>(
      `${environment.baseUrl}/v1/products/createproduct`,
      request
    )
  }

  updateProduct(request : IUpdateProductRequest){
    return this.http.put<IProduct>(
      `${environment.baseUrl}/v1/products/updateproduct/${request.id}`,
      request
    )
  }

  deleteProduct(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/products/deleteproduct/${id}`
    )
  }

  importProducts(formData: FormData): Observable<any> {
    return this.http.post(
      `${environment.baseUrl}/v1/products/importProducts`, 
      formData
    );
  }
}
